/**
 * Converts an index to an alphabetic character, where 0 is A, 1 is B, 25 is Z, 26 is AA, etc.
 */
export function indexToAlpha(index: number) {
  let alpha = '';
  while (index >= 0) {
    alpha = String.fromCharCode((index % 26) + 65) + alpha;
    index = Math.floor(index / 26) - 1;
  }
  return alpha;
}
